export default {
  state: {
    // 国际酒店每间夜价格详情
    avgPrice: null,
  },
  mutations: {
    setAvgPrice(state, data) {
      state.avgPrice = data;
    },
  },
  actions: {},
};
